import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Actions = styled.div`
  display: flex;
  gap: 15px;
  margin-top: 15px;
`;

export const Contacts = styled.div`
  display: grid;
  justify-items: center;
  gap: 15px;
  padding: 30px 0;
`;

export const ContactsText = styled(Typography.Body)`
  text-align: center;
`;
